'use strict';

angular.module('myConsultApp')
  .filter('url', function () {
    return function (s) {
        if ( s === undefined || s === null){
            return '';
        }

        if (!/^https?:\/\//i.test(s)) {
            s = 'http://' + s;
        }
        return s;
    };
  })
  .filter('filename', function() {
          return function(input) {
         return input.split('/').pop();
       }
   });


